import { colorsPalettes } from "@similarweb/styles";

import { Intent } from "app/pages/website-analysis/traffic-sources/search/common/intent.configuration";
import { translate } from "app/filters/i18nFilter";
import { pctSignFilter, percentageFilter } from "app/filters/ngFilters";

import type { IIntentDistributionChartData, ITrafficShareItem } from "./intentDistributionChartTypes";

const FractionLength = 1;

export const getColorByType = (type: Intent): string => {
    switch (type) {
        case Intent.Informational:
            return colorsPalettes.midnight[300];
        case Intent.Transactional:
            return colorsPalettes.orange[400];
        case Intent.Navigational:
            return colorsPalettes.mint[400];
        case Intent.Local:
            return colorsPalettes.solutions.SALES;
        case Intent.JobSearch:
            return colorsPalettes.solutions.DIGITAL_RESEARCH;
        default:
            return colorsPalettes.carbon[500];
    }
};

const getPercentageText = (data: number): string => `${pctSignFilter()(percentageFilter()(data || 0, FractionLength))}`;

export const mapDataToIntentItemConfigs = (data: IIntentDistributionChartData): ITrafficShareItem[] => {
    return [
        {
            type: Intent.Informational,
            name: translate("keywords.table.filters.intent.informational"),
            width: Math.round(data.informational * 100),
            color: colorsPalettes.carbon[0],
            backgroundColor: getColorByType(Intent.Informational),
            text: getPercentageText(data.informational),
        },
        {
            type: Intent.Transactional,
            name: translate("keywords.table.filters.intent.transactional"),
            width: Math.round(data.transactional * 100),
            color: colorsPalettes.carbon[0],
            backgroundColor: getColorByType(Intent.Transactional),
            text: getPercentageText(data.transactional),
        },
        {
            type: Intent.Navigational,
            name: translate("keywords.table.filters.intent.navigational"),
            width: Math.round(data.navigational * 100),
            color: colorsPalettes.carbon[0],
            backgroundColor: getColorByType(Intent.Navigational),
            text: getPercentageText(data.navigational),
        },
        {
            type: Intent.Local,
            name: translate("keywords.table.filters.intent.local"),
            width: Math.round(data.local * 100),
            color: colorsPalettes.carbon[0],
            backgroundColor: getColorByType(Intent.Local),
            text: getPercentageText(data.local),
        },
        {
            type: Intent.JobSearch,
            name: translate("keywords.table.filters.intent.job.search"),
            width: Math.round(data.job_search * 100),
            color: colorsPalettes.carbon[0],
            backgroundColor: getColorByType(Intent.JobSearch),
            text: getPercentageText(data.job_search),
        },
    ];
};
